import Vue from "vue"
import Vuex from "vuex"
import vuexI18n from "vuex-i18n"

const store = new Vuex.Store()
Vue.use(vuexI18n.plugin, store)
